function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89,
    height: 3,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 61",
    transform: "translate(1.5 1.5)",
    style: {
      fill: "none",
      stroke: "#ffbd1f",
      strokeLinecap: "round",
      strokeWidth: 3
    },
    d: "M0 0h86"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLine);
export default __webpack_public_path__ + "static/media/yellowLine.12ed9cae4bd00ab37ddaaa50e534b39b.svg";
export { ForwardRef as ReactComponent };